
$(document).ready(function () {
	//var experiencesLoadUrl = $("#experiencesListSection [data-load-more-url]").data('load-more-url');
	$("#experiencesListSection").on('click', '[data-load-more-url]', function (e) {

		var experiencesLoadUrl = $("#experiencesListSection [data-load-more-url]").attr('data-load-more-url');

		e.preventDefault();
		$.ajax({
			url: experiencesLoadUrl,
			beforeSend: function () {
				$('#load-more-spinner').toggleClass("hidden");
				$("[data-load-more-url]").toggleClass("hidden");
			},
			success: function (data) {
				$('#load-more-spinner').toggleClass("hidden");
				$("[data-load-more-url]").toggleClass("hidden");
				var newPageElements = $(data).find("#experiencesList .experiences-list--wrap");
				$("#experiencesList .experiences-list--wrap").append(newPageElements.html());
				var lastPage = $("#experiencesList .experiences-list--wrap").attr("data-experiences-last-page");
				var newCurrentPage = newPageElements.data("experiences-current-page");
				var newPageUrl = newPageElements.data("page-url");

				// Making sure we use the same origin to avoid SOP errors
				let newPageUrlInstance = new URL(newPageUrl);
				if (newPageUrlInstance.origin !== location.origin) {
					const cleanNewPageUrl = `${location.origin}${newPageUrlInstance.pathname}${newPageUrlInstance.search}`
					newPageUrlInstance = new URL(cleanNewPageUrl);
				}

				try {
					window.history.pushState(newPageUrl, '', newPageUrlInstance);
				} catch (e) {
					console.log(`
						Error while trying to push a new URL parameter:
						\n${e}
						\nTo the URL: ${newPageUrlInstance}
					`)
				}

				if (parseInt(lastPage) == parseInt(newCurrentPage)) {
					$("[data-load-more-url]").remove();
				} else {
					var nextPageUrl = $(data).find("[data-load-more-url]").data("load-more-url");
					$("#experiencesList [data-load-more-url]").attr("data-load-more-url", nextPageUrl);
					experiencesLoadUrl = nextPageUrl;
				}

				$("#experiencesList .experiences-list--wrap").attr("data-experiences-current-page", newCurrentPage);
				$("#experiencesList .experiences-list--wrap").attr("data-page-url", newPageUrl);

				// bLazy.revalidate();
			}, cache: false
		}).then(function () {
			// bLazy.revalidate();
		});

		// setTimeout(function () {
		//     bLazy.revalidate();
		// }, 500);
	});
});



// WEBPACK FOOTER //
// ./src/main/resources/assets/js/authentic/experiences.js